import ListItem from './ListItem';
import ListHeader from './ListHeader';
import '../styles/components/list.css';
import { useState, useEffect } from 'react';

const List = ({
                headers,
                data,
                showCheckbox = true,
                onItemCheck,
                onItemClick,
                columnWidths = null
              }) => {
  const [checkedStates, setCheckedStates] = useState([]);

  useEffect(() => {
    setCheckedStates(data.map(() => false));
  }, [data]);

  const handleItemCheck = (index, checked) => {
    const newChecked = [...checkedStates];
    newChecked[index] = checked;
    setCheckedStates(newChecked);
    if (onItemCheck) onItemCheck(index, checked);
  };

  const handleItemClick = (item, index) => {
    if (onItemClick) onItemClick(item, index);
  };

  const isAllChecked = checkedStates.length > 0 && checkedStates.every(Boolean);
  const isPartiallyChecked = checkedStates.some(Boolean) && !isAllChecked;

  const handleCheckAll = () => {
    const newValue = !isAllChecked;
    const newChecked = data.map(() => newValue);
    setCheckedStates(newChecked);
    if (onItemCheck) {
      newChecked.forEach((checked, idx) => onItemCheck(idx, checked));
    }
  };

  return (
      <div className="list-container">
        <ListHeader
            headers={headers}
            showCheckbox={showCheckbox}
            onCheckAll={handleCheckAll}
            isAllChecked={isAllChecked}
            isPartiallyChecked={isPartiallyChecked}
            columnWidths={columnWidths} 
        />
        <div className="list-content">
          {data.map((item, index) => (
              <ListItem
                  key={index}
                  item={item}
                  isChecked={checkedStates[index]}
                  showCheckbox={showCheckbox}
                  onCheck={(checked) => handleItemCheck(index, checked)}
                  onClick={() => handleItemClick(item, index)}
                  columnWidths={columnWidths} 
              />
          ))}
        </div>
      </div>
  );
};

export default List;
